var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "autocomplete",
      class: {
        focused: _vm.focused,
        active: _vm.showList,
        loading: _vm.loading,
        invalid: _vm.invalid,
      },
    },
    [
      _vm.label
        ? _c("div", { staticClass: "label hidden-label" }, [
            _vm._v(" " + _vm._s(_vm.label) + " "),
          ])
        : _vm._e(),
      _c("div", { staticClass: "wrapper" }, [
        _c("div", { staticClass: "field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localValue,
                expression: "localValue",
              },
            ],
            attrs: { type: "text" },
            domProps: { value: _vm.localValue },
            on: {
              focus: _vm.onFocus,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.localValue = $event.target.value
              },
            },
          }),
          _vm.localValue
            ? _c(
                "div",
                { staticClass: "clear" },
                [
                  _c("svg-icon", {
                    attrs: { name: "times", color: "secondary" },
                    on: { click: _vm.clear },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.label
            ? _c(
                "div",
                {
                  staticClass: "label visible-label",
                  class: {
                    active: _vm.localValue,
                  },
                },
                [
                  _vm._v(" " + _vm._s(_vm.label) + " "),
                  _vm.requiredMark
                    ? _c("span", { staticClass: "required-mark" }, [
                        _vm._v("*"),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "lock", on: { click: _vm.openContainer } }),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showList,
                expression: "showList",
              },
            ],
            ref: "container",
            staticClass: "container",
          },
          [
            _c(
              "div",
              { staticClass: "container__wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "search" },
                  [
                    _c("div", { staticClass: "search__icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 17 17",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M11.4142 11L15.6569 15.2426M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                              "stroke-width": "2",
                              stroke: "#bfc9e0",
                              "stroke-linecap": "round",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.query,
                          expression: "query",
                        },
                      ],
                      ref: "searchInput",
                      staticClass: "search__input",
                      attrs: { type: "text", placeholder: "Поиск" },
                      domProps: { value: _vm.query },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.query = $event.target.value
                        },
                      },
                    }),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.query
                        ? _c(
                            "div",
                            {
                              staticClass: "search__clear",
                              on: { click: _vm.resetSearch },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 12 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
                !_vm.loading && !_vm.list.length
                  ? _c("div", { staticClass: "empty" }, [
                      _vm._v("Ничего не найдено"),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "list" },
                  _vm._l(_vm.list, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "list-item",
                        on: {
                          click: function ($event) {
                            return _vm.select(item)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(item.text) + " ")]
                    )
                  }),
                  0
                ),
                _vm.loading
                  ? _c("loader", {
                      staticClass: "loader",
                      attrs: { active: _vm.loading },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("c-button", {
                      staticClass: "actions__cancel",
                      attrs: { size: "small", label: "Отмена" },
                      on: { click: _vm.close },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm.error
        ? _c("error-feedback", { attrs: { text: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }